module.exports = __webpack_public_path__ + "img/quote.65c1f070.svg";